import {interactivePortalStyle} from "../constants/ModalLayers";

export const configureMaterialUiMenuDefaultProps = (defaultProps = {}) => ({
  ...defaultProps,
  style:{
    ...(defaultProps.style || {}),
    ...interactivePortalStyle
  }
});

export const portalClassNameForModal = (presentedInsideParentModal) => {
  return 'react-modal-portal' + (presentedInsideParentModal ? ' react-modal-portal-nested' : '');
};
